export default "__VITE_ASSET__NVS43VNJ__"